export default __webpack_public_path__ + "media/images/icons/Derecha-5516cda8efec34b320f2f75a14aa1022.svg";